import React from 'react'
import "./works.css"
import Upwork from "../../img/Upwork.png"
import Fiverr from "../../img/fiverr.png"
import Amazon from "../../img/amazon.png"
import Shopify from "../../img/Shopify.png"
import Facebook from "../../img/Facebook.png"


const Works = () => {
  return (
    <div className="works">
         <div className="awesome">
        <span>Works for All these</span>
        <span>Brands & Clients</span>
        <span>
         Collaborated with startups and established brands to deliver tailored web solutions.
         <br/>
         Developed user-friendly websites that increased engagement and sales for clients.
         <br/>
         Focused on understanding client needs to create effective and innovative digital experiences
        </span> 

        <button className="button s-button">Hire me</button>  
        <div className="blur s-blurl" style={{ background: "#ABF1FF94"}}></div>


      </div>
      
      <div className="w-right">
        <div className="w-mainCircle">
          <div className="w-secCircle">
            <img src={Upwork} alt=""/>
          </div>
          <div className="w-secCircle">
            <img src={Fiverr} alt=""/>
          </div>
          <div className="w-secCircle">
            <img src={Amazon} alt=""/>
          </div>
          <div className="w-secCircle">
            <img src={Shopify} alt=""/>
          </div>
          <div className="w-secCircle">
            <img src={Facebook} alt=""/>
          </div>
        </div>
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>

      </div>
    </div>
  )
}

export default Works
